const env = process.env.NODE_ENV // 环境
const conf = {
production: {
// api路径
baseUrl: "http://192.168.1.227:9999",
},
development: {
// api路径
baseUrl: "http://127.0.0.1:14004",
},
}
module.exports= {
...conf[env],
//应用名称
name:"",
//用户令牌键名
tokenKey:"用户令牌",
//高德密钥
secretKey:"",
//高德key
gdKey:"",
}